import { Triplet, useCompoundBody } from "@react-three/cannon";
import { useMemo, useRef, useState } from "react";
import { Group, MeshBasicMaterial, TextureLoader } from "three";
import { Box, ObjectProps, useDragConstraint } from "../utils";
import { useLoader, useFrame } from "@react-three/fiber";
import { asset } from "../../consts";

export default ({position, rotation}: ObjectProps) => {
  const [currentFrame, setCurrentFrame] = useState(0);
  const lastUpdateTimeRef = useRef(0);
 
  const nyanCatImages = useLoader(TextureLoader, [
    asset('/images/nyan-cat/0.gif'),
    asset('/images/nyan-cat/1.gif'),
    asset('/images/nyan-cat/2.gif'),
    asset('/images/nyan-cat/3.gif'),
    asset('/images/nyan-cat/4.gif'),
    asset('/images/nyan-cat/5.gif'),
    asset('/images/nyan-cat/6.gif'),
    asset('/images/nyan-cat/7.gif'),
    asset('/images/nyan-cat/8.gif'),
    asset('/images/nyan-cat/9.gif'),
  ]);

  useFrame((state) => {
    const currentTime = state.clock.getElapsedTime();
    if (currentTime - lastUpdateTimeRef.current >= 0.1) {
      setCurrentFrame((prev) => (prev + 1) % nyanCatImages.length);
      lastUpdateTimeRef.current = currentTime;
    }
  });

  const materials = useMemo(() => {
    return [
      new MeshBasicMaterial({color: 'white'}),
      new MeshBasicMaterial({color: 'white'}),
      new MeshBasicMaterial({color: 'white'}),
      new MeshBasicMaterial({color: 'white'}),
      new MeshBasicMaterial({ map: nyanCatImages[currentFrame] }),
      new MeshBasicMaterial({color: 'white'}),
    ];
  }, [nyanCatImages, currentFrame]);

  const [ref] = useCompoundBody(() => ({
    mass: 30,
    position: position ?? [0, 0, 0],
    rotation: rotation ?? [0, 0, 0],
    shapes: [
      // { args: [2.5, 1.5, 0.2], mass: 15, position: [0, 0, 0], type: 'Box' },
      // { args: [5.4, 3.2, 0.1], mass: 15, position: [0, 0, 0.15], type: 'Box' },
    ], 
    type: 'Static'
  }), useRef<Group>(null));
  const bind = {}; // useDragConstraint(ref);
  const handlePointerEnter = () => { document.body.style.cursor = 'pointer'; };
  const handlePointerLeave = () => { document.body.style.cursor = 'default'; };
  const handleClick = () => {
    document.body.style.cursor = 'default';
    // memo: HashRouter利用のため、配信先サブパスを保ったままハッシュのみ変更する。
    window.location.hash = '#/MonitorProject';
  };
  return (
    <group
      ref={ref}
      {...bind}
      onPointerEnter={handlePointerEnter}
      onPointerLeave={handlePointerLeave}
      onClick={handleClick}
    >
      <Box args={[2.5, 1.5, 0.2]} />
      <mesh position={[0, 0, 0.15]} castShadow receiveShadow material={materials}>
        <boxGeometry args={[5.4, 3.2, 0.1]} />
      </mesh>
    </group>
  );
};
